<template>
  <div class="auth-page">
    <UcariHeader />
    <main class="system-page">
    <form @submit.prevent="requestPasswordReset" class="system-card system-card--form">
      <span class="system-card__icon" uk-icon="icon: mail; ratio: 1.5"></span>
      <span class="eyebrow">Account help</span>
      <h1>Reset your password</h1>
      <p>Enter the email address associated with your account and we'll send you a link to reset your password.</p>
      <div v-if="error" class="uk-alert-danger" role="alert">{{ error }}</div>
      <div v-if="message" class="uk-alert-success" role="status">{{ message }}</div>
      <div class="uk-margin">
        <label for="email">Email</label>
        <input id="email" class="uk-input" type="email" autocomplete="email" v-model="email" required />
      </div>
      <button type="submit" class="uk-button uk-button-primary uk-width-1-1 uk-margin">Send reset link</button>
      <div class="uk-text-center"><router-link to="/login">Return to sign in</router-link></div>
    </form>
    </main>
    <RetailerFooter />
  </div>
</template>

<script>
import axios from 'axios';
import UcariHeader from './components/UcariHeader.vue'; 
import RetailerFooter from './components/RetailerFooter.vue'; 

export default {
  name: 'RequestPasswordReset',
  created() {
    document.title = 'Password Reset | UCARI';
  },
  components: {
    UcariHeader,  
    RetailerFooter
  },
  data() {
    return {
      email: '',
      message: '',
      error: ''
    };
  },
  methods: {
    async requestPasswordReset() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/api/retailer/request-password-reset`, { email: this.email });
        this.message = response.data.message;
        this.error = '';
        this.$router.push('/request-password-reset-successful');
      } catch (error) {
        this.error = error.response?.data?.error || 'An error occurred';
        this.message = '';
      }
    }
  }
};
</script>
